export default __webpack_public_path__ + "static/media/barcode.1a703db5.svg";